import { useContext } from 'react';

import Layout from '../components/Layout';
import Map from '../components/Map';
import FViewPedido from '../components/admin/fViewPedido';
import FormPedido from '../components/formPedido';


const Pedido = () => {

	return (
		<Layout
			pagina={"Mi compra"}
		>
			<div className='w-full pt-20 pb-20'>
				<FViewPedido />
			</div>
		</Layout>
	)
}

export default Pedido